// Render-only smoothing between the last two authoritative snapshots.
// SPEC.md §1.1: "the client may interpolate/predict for smoothness, but
// every authoritative fact ... comes from the server snapshot." This module
// only ever blends two ALREADY-authoritative x/y pairs for drawing; it never
// writes back into anything treated as truth (score/lives/dots/etc. are
// always read straight off the latest snapshot, see GameCanvas.tsx).
export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

/** Guards against interpolating across a teleport (tunnel wrap, respawn,
 * level reset) where the naive lerp would draw a Pac-Man sliding across the
 * whole maze in one frame. */
export function lerpWrapAware(a: number, b: number, t: number, span: number): number {
  const raw = Math.abs(b - a);
  if (raw > span / 2) return b; // treat as a teleport, snap to authoritative
  return lerp(a, b, t);
}
